import { DESCRIPTION_SUFFIX } from "@/constant";

export const setTitleAndDescription = ({title}) => {
    const finalTitle = title || (process.env.REACT_APP_PROJECT_NAME || 'Impulse');
    document.title = finalTitle;

    let descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
        descriptionTag.setAttribute("content", `${finalTitle} - ${DESCRIPTION_SUFFIX}`);
    }
}